module.exports = __webpack_public_path__ + "img/sysMaintain.762eedda.png";